import { SkeletonLoader } from "@merge-api/merge-javascript-shared";

type TableSkeletonLoaderProps = {
  cols?: number;
  rows?: number;
};
const TableSkeletonLoader = ({ cols = 7, rows = 5 }: TableSkeletonLoaderProps) => {
  const skeletonRows = Array.from({ length: rows }).map((_, i) => (
    <tr key={`skel-row-${i}`} className="w-3">
      {Array.from({ length: cols }).map((_, j) => (
        <td key={`skel-cell-${j}`}>
          <SkeletonLoader fullWidth height={20} borderRadius={8} />
        </td>
      ))}
    </tr>
  ));

  return <>{skeletonRows}</>;
};
export default TableSkeletonLoader;
